import TabsHeader from 'components/tabs-header';
import { useAccountState } from 'contexts/account/account-context';
import { Wrench } from 'lucide-react';
import { FC, memo } from 'react';
import { useIntl } from 'react-intl';
import { UserFeatures } from 'types/user-features.enum';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
};

const SelfServiceTabsHeader: FC<Props> = ({ intro, actions, utils }) => {
  const intl = useIntl();
  const {
    account: { company },
  } = useAccountState();

  return (
    <TabsHeader
      tabs={[
        {
          hasAccess: company?.userCompanyFeatures?.includes(UserFeatures.SelfService),
          label: intl.formatMessage({ id: 'selfService.feedCatalog.title' }),
          to: `/self-service/feed-catalog/`,
        },
        {
          hasAccess: company?.userCompanyFeatures?.includes(UserFeatures.SelfService),
          label: intl.formatMessage({ id: 'selfService.treatmentCatalog.title' }),
          to: `/self-service/treatment-catalog/`,
        },
        {
          hasAccess: company?.userCompanyFeatures?.includes(UserFeatures.SelfService),
          label: intl.formatMessage({ id: 'selfService.aerators.title' }),
          to: `/self-service/aerators/`,
        },
        {
          hasAccess: company?.userCompanyFeatures?.includes(UserFeatures.SelfService),
          label: intl.formatMessage({ id: 'selfService.feeders.title' }),
          to: `/self-service/feeders/`,
        },
      ]}
      intro={intro}
      actions={actions}
      utils={utils}
      icon={<Wrench size={25} color={'white'} />}
    />
  );
};

export default memo(SelfServiceTabsHeader);
